module.exports = __webpack_public_path__ + "static/img/9.b5cb42d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/3/sp/9.png
// module id = FMDu
// module chunks = 0